import { Component, OnInit, ViewChild } from '@angular/core';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { Segcompilar } from "../seginterfaces/segcompilar";
import { SegtrncompilarpaquetesService } from "../segservicios/segtrncompilarpaquetes.service";
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
@Component({
  selector: 'app-segtrncompilarpaquetes',
  templateUrl: './segtrncompilarpaquetes.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class SegtrncompilarpaquetesComponent implements OnInit {

  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  public frameworkComponents;
  rowStyle;
  largo: string;

  cmbTipo: any[];
  strTipo: any;
  detreg: Segcompilar[] = []
  defaultregcompilar
  rowSelection = 'multiple';
  index = 0
  segcompilaSeleccionarTodo: boolean
  columnDefsregcompilar = [
    {
      headerName: 'Sel', field: 'CHECKCONT', cellRendererFramework: AggridBanComponent, editable: false, width: 50
    },
    {
      headerName: 'Nombre', field: 'NOMBRE_PROCESO', editable: false, width: 250
    },
    {
      headerName: 'Log', field: 'LOG', editable: false, width: 400
    },

  ];

  constructor(
    public segtrncompilarpaquetesService: SegtrncompilarpaquetesService, private messageService: MessageService, public init: NuevoComponentService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.defaultregcompilar = {
      editable: true,
      objeto: 'segcmpilar'
    };
  }
  ngOnInit() {

    this.cmbTipo = [];
    this.cmbTipo.push({ name: 'TODOS', codigo: 'todos' },
      { name: 'FUNCIONES', codigo: 'FUNCTION' },
      { name: 'PROCESOS', codigo: 'PROCEDURE' },
      { name: 'PAQUETES', codigo: 'PACKAGE' });

    this.strTipo = this.cmbTipo[0];
    this.segcompilaSeleccionarTodo = false
  }
  manejarSenales(evento) {
    if (evento === 'Visto') {
      this.procesar()

    }
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  changeTabs() {

  }
  async procesar() {
    try {
      for (const iterator of this.detreg) {
        if (iterator.CHECKCONT === true) {
          await this.segtrncompilarpaquetesService.procesarpaquete(iterator.TIPO_PROCESO, iterator.NOMBRE_PROCESO)
        }


      }
      this.messageService.add({
        key: 'segcompilar',
        severity: 'success',
        summary: 'Seguridades',
        detail: 'Proceso ejecutado con éxito'
      });

    } catch (error) {

    }

  }
  seleccionItem(evento) {

  }
  async consultar() {
    try {

      const rs = await this.segtrncompilarpaquetesService.consultarpaquetes(this.strTipo.codigo)
      
      if (rs.length > 0 && rs !== null) {
        this.detreg = []
        for (const iterator of rs) {
          iterator.CHECKCONT=false
        }
        this.detreg = rs
      }
      this.messageService.add({
        key: 'segcompilar',
        severity: 'success',
        summary: 'Seguridades',
        detail: 'Proceso ejecutado con éxito'
      });
    } catch (error) {

    }

  }
  seleccionarTodo() {
    if (this.segcompilaSeleccionarTodo === true) {
      for (const iterator of this.detreg) {
        iterator.CHECKCONT = true
      }
    } else {
      for (const iterator of this.detreg) {
        iterator.CHECKCONT = false
      }
    }
    this.aggrid.refreshaggrid(this.detreg,this.defaultregcompilar.objeto)
  }
}
